import * as React from 'react';
import styled from '@independent-software/typeui/styles/Theme'
import { css } from 'styled-components';

class SectionBase extends React.Component<{ className?: string; padded?: boolean | 'very', stretched?: boolean, dark?: boolean}, {}> {
  render() {
    let p = this.props;
    return (
      <div className={p.className}>{p.children}</div>
    );
  }
}

const Section = styled(SectionBase)`
  position: relative;
  ${p => p.padded && p.padded == 'very' && css`padding: 25px 25px 25px 25px;`}
  ${p => p.padded && p.padded != 'very' && css`padding: 5px 25px 5px 25px;`}
  ${p => p.stretched && css`flex:1;`}
  ${p => p.dark && css`background: #eee;`}
  margin-bottom: 5px;
`
export { Section }